import { eventHowxm, identifyHowxm, initHowxm } from 'howxm-js';
import { toString } from '@libs/shared';
import { authModel, globalState } from '../models';

/**
 * 初始化浩客
 * @param isSuiteManager 是否为套件管理员
 * @param howxmProjectId 子产品传入的浩客 appId，优先级高于 public_configuration
 */
export const initHowxmConfig = (isSuiteManager = false, howxmProjectId?: string) => {
    const appId = howxmProjectId || globalState.options?.howxm_project_id;

    if (appId) {
        const {
            tenantId,
            currentCorpName,
            memberId,
            userId,
            currentCorpType,
            suiteVipLevel,
            isCorpOwner,
            hasSysAdmin,
            hasPlatformManager,
            isSyncMember,
            userRegTime
        } = authModel;

        initHowxm(appId);
        identifyHowxm({
            uid: [tenantId, memberId].join('-'),
            user_id: userId!,
            tenant_id: tenantId!,
            corp_name: currentCorpName!,
            corp_type: currentCorpType!,
            vip: suiteVipLevel!,
            is_owner: toString(isCorpOwner),
            is_admin: toString(hasSysAdmin),
            is_corp_manager: toString(hasPlatformManager || isSuiteManager),
            is_sync_user: toString(isSyncMember),
            user_reg_time_at: userRegTime || ''
        });

        globalState.isHowxmInit = true;
    }
};

/**
 * 触发浩客事件
 * @param eventCode 运营提供
 * @param eventAttrs 运营提供
 */
export const triggerHowxmEvent = (
    eventCode: string,
    eventAttrs?: Record<string, string | number | boolean | Date>
) => {
    if (globalState.isHowxmInit) {
        eventHowxm(eventCode, eventAttrs);
    }
};
